import type { UserRole } from '~/types/user'

export default defineNuxtRouteMiddleware(async (to, from) => {
    const user = await useAuthStore().setUser()
    if (!user) {
        return navigateTo('/login')
    }

    const roles = (to.meta.roles as UserRole[]) || []
    if (roles.length && !roles.includes(user.role)) {
        return navigateTo('/')
    }
})
